/* eslint-disable import/extensions */
import { GraphQLClient } from 'graphql-request'
import { REACT_APP_API_URL } from './apollo/REACT_APP_URL'

// import API_END_POINT from './env'
const API_END_POINT = `${REACT_APP_API_URL}/graphql`

let token = ''
if (!(localStorage.getItem('token') === null) && localStorage.getItem('token')) {
  token = JSON.parse(localStorage.getItem('token'))
}

const client = new GraphQLClient(API_END_POINT, {
  headers: {
    database: 'india',
    Authorization: token ? `JWT ${token}` : '',
  },
})

export default client
